import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import { subAdminColumns } from "../../tables/subAdminColumns";

export default function ViewSubAdmin() {
    const PAGE_SIZE = 10;
    const token = localStorage.getItem("adminToken");
    const API_URL = process.env.REACT_APP_BASE_URL_API || "";
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [totalPages, setTotalPages] = useState(1);
    const [listLoading, setListLoading] = useState(false);
    const [sortBy, setSortBy] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");
    const [subadmin, setSubadmin] = useState([]); // ✅ missing state

    /* ================= FETCH LIST ================= */
    const fetchAdmins = async () => {
        setListLoading(true);
        try {
            const res = await fetch(
                `${API_URL}/api/admin/sub-admin-list?page=${page}&limit=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = await res.json();
            setSubadmin(data.data || []);
            setTotalPages(data.totalPages || 1);
        } catch (err) {
            console.error(err);
        } finally {
            setListLoading(false);
        }
    };

    useEffect(() => {
        fetchAdmins();
    }, [page, pageSize, sortBy, sortOrder]);

    /* ================= EDIT ================= */
    const handleEdit = (row) => {
        window.location.href = `/admin/roles-permissions/update/${row._id}`;
    };

    /* ================= DELETE ================= */
    const handleDelete = async (id) => {
        if (!window.confirm("Delete this subadmin?")) return;

        try {
            await fetch(`${API_URL}/api/admin/sub-admin-list/delete/${id}`, {
                method: "DELETE",
                headers: { Authorization: `Bearer ${token}` },
            });
            fetchAdmins();
        } catch (err) {
            console.error(err);
        }
    };
    // view Premintion

    const viewPermission = async (id) => {
       window.location.href =`/admin/roles-permissions/view-permission/${id}`;
    };

    const columns = subAdminColumns({
        PAGE_SIZE,
        handleEdit,
        handleDelete,
        viewPermission
    });

    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />
                <Header pageTitle="View Sub Admin" />

                <>
                    <div className="right_col" role="main">
                        

                        <div className="clearfix" />

                        <div className="x_panel">
                            <div className="x_title">
                                <h2>Sub Admin List</h2>
                                <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                                    <li>
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up" />
                                        </a>
                                    </li>
                                </ul>
                                <div className="clearfix" />
                            </div>

                            <div className="x_content">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <AdminDataTable
                                            columns={columns}
                                            data={subadmin}
                                            page={page}
                                            pageSize={pageSize}
                                            totalPages={totalPages}
                                            loading={listLoading}
                                            onPageChange={setPage}
                                            onPageSizeChange={(size) => {
                                                setPageSize(size);
                                                setPage(1);
                                            }}
                                            sortBy={sortBy}
                                            sortOrder={sortOrder}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

                <Footer />
            </div>
        </div>
    );
}
